import { createFileRoute, notFound } from "@tanstack/react-router";
import {
  VO_QA,
  VO_QA_BY_SLUG,
  VO_REVIEWED_ISO,
  VO_REVIEWED_TH,
} from "@/data/virtual-office/questions";
import { ClusterQaDetail, clusterQaDetailHead, type ClusterQaMeta } from "@/lib/qa/cluster-pages";

const M: ClusterQaMeta = {
  base: "/virtual-office",
  label: "ที่ตั้งสำนักงาน จดบริษัท และจดทะเบียนภาษีมูลค่าเพิ่ม",
  reviewedIso: VO_REVIEWED_ISO,
  reviewedTh: VO_REVIEWED_TH,
};

export const Route = createFileRoute("/virtual-office/q/$slug")({
  loader: ({ params }) => {
    if (!VO_QA_BY_SLUG[params.slug]) throw notFound();
    return { slug: params.slug };
  },
  head: ({ loaderData }) =>
    clusterQaDetailHead(M, loaderData ? VO_QA_BY_SLUG[loaderData.slug] : undefined),
  component: Page,
});

function Page() {
  const { slug } = Route.useLoaderData();
  const qa = VO_QA_BY_SLUG[slug];
  if (!qa) throw notFound();
  return <ClusterQaDetail m={M} qa={qa} all={VO_QA} />;
}
